"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.push = push;
exports.pop = pop;
exports.pushf = pushf;
exports.popf = popf;
exports.atsp = atsp;
exports.swap = swap;
exports.setspc = setspc;
const register_values_1 = require("./register-values");
function encodeFlags(flags) {
    return (flags.c ? 1 : 0)
        | (flags.z ? 2 : 0)
        | (flags.s ? 4 : 0)
        | (flags.v ? 8 : 0);
}
function decodeFlags(flags, value) {
    flags.c = (value & 1) !== 0;
    flags.z = (value & 2) !== 0;
    flags.s = (value & 4) !== 0;
    flags.v = (value & 8) !== 0;
}
function registerByteLength(source) {
    switch (source.kind) {
        case "B":
        case "A":
            return 1;
        case "I":
            return 2;
        case "L":
            return 4;
    }
}
function push(registers, stack, source) {
    let value = (0, register_values_1.getIntValue)(registers, source) >>> 0;
    const length = registerByteLength(source);
    for (let i = 0; i < length; i += 1) {
        stack.pushByte(value & 0xff);
        value >>>= 8;
    }
}
function pop(registers, stack, destination) {
    const length = registerByteLength(destination);
    if (stack.depth() < length) {
        throw new RangeError("Stack underflow");
    }
    let value = 0;
    for (let i = 0; i < length; i += 1) {
        value = (value << 8) | stack.popByte();
    }
    (0, register_values_1.setIntValue)(registers, destination, value >>> 0);
}
function pushf(stack, flags) {
    let value = encodeFlags(flags) >>> 0;
    for (let i = 0; i < 4; i += 1) {
        stack.pushByte(value & 0xff);
        value >>>= 8;
    }
}
function popf(stack, flags) {
    if (stack.depth() < 4) {
        throw new RangeError("Stack underflow");
    }
    let value = 0;
    for (let i = 0; i < 4; i += 1) {
        value = (value << 8) | stack.popByte();
    }
    decodeFlags(flags, value >>> 0);
}
function atsp(registers, stack, destination, offset = 0) {
    const length = registerByteLength(destination);
    const index = offset - length;
    if (index < 0) {
        throw new RangeError("Invalid stack index");
    }
    let value = 0;
    for (let i = 0; i < length; i += 1) {
        const byte = stack.peekByte(index + i) ?? 0;
        value = (value << 8) | byte;
    }
    (0, register_values_1.setIntValue)(registers, destination, value >>> 0);
}
function swap(registers, destination, start, length) {
    if (length <= 0) {
        return;
    }
    const maxSize = registers.getMaxStringSize();
    if (start + length > maxSize) {
        throw new Error("Swap exceeds maximum string size");
    }
    const current = (0, register_values_1.getBinaryValue)(registers, destination);
    const requiredLength = Math.max(current.length, start + length);
    const buffer = new Uint8Array(Math.min(requiredLength, maxSize));
    buffer.set(current.slice(0, buffer.length));
    const slice = buffer.slice(start, start + length).reverse();
    buffer.set(slice, start);
    (0, register_values_1.setBinaryValue)(registers, destination, buffer);
}
function setspc(stack, depth) {
    stack.setDepth(depth);
}
//# sourceMappingURL=stack.js.map